// extracted by mini-css-extract-plugin
export var articleSection = "blog-post-module--article-section--FsG27";
export var blog_newsletter = "blog-post-module--blog_newsletter--aSiMV";
export var innerWrapper = "blog-post-module--inner-wrapper--m5r6F";
export var mainContent = "blog-post-module--main-content--VDiWv";
export var outerWrapper = "blog-post-module--outer-wrapper--tfdSK";